export enum SchedulingModalityEnum {
  DEALER = 'DEALER',
  PDL = 'PDL',
  MSV = 'MSV',
  WINCH = 'WINCH',
  GENERAL_REPAIR = 'GR',
  PICK_AND_DROP = 'PUD',
  PICKUP_AND_DELIVERY = 'PUD',
  PICKUP_ONLY = 'PUD2',
  DELIVERY_ONLY = 'PUD3',
  XPRESS_SERVICE = 'XPR',
}

